import axios from './axiosInstance';

export const getVesselMainEngineData = async (
  vesselId,
  engineId,
  startDate,
  endDate,
  voyageId = null
) => {
  const url = `/vessels/${vesselId}/main-engine/${engineId}`;
  const params = {};

  if (!voyageId) {
    params.start = startDate;
    params.end = endDate;
  } else {
    params.voyageId = voyageId;
  }

  const res = await axios.get(url, { params });
  return res.data;
};

export const getVesselFuelVsMcr = async (
  vesselId,
  engineId,
  startDate,
  endDate,
  voyageId = null
) => {
  const url = `/vessels/${vesselId}/main-engine/fuel-vs-mcr/${engineId}`;
  const params = {};

  if (!voyageId) {
    params.start = startDate;
    params.end = endDate;
  } else {
    params.voyageId = voyageId;
  }

  const res = await axios.get(url, { params });
  console.log("resRPMVMCR", res.data.data);
  return res.data.data;
};

export const getVesselRpmVsMcr = async (
  vesselId,
  engineId,
  startDate,
  endDate,
  voyageId = null
) => {
  const url = `/vessels/${vesselId}/main-engine/rpm-vs-mcr/${engineId}`;
  const params = {};

  if (!voyageId) {
    params.start = startDate;
    params.end = endDate;
  } else {
    params.voyageId = voyageId;
  }

  const res = await axios.get(url, { params });
  return res.data.data;
};

export const getVesselFuelVsRpm = async (
  vesselId,
  engineId,
  startDate,
  endDate,
  voyageId = null
) => {
  const url = `/vessels/${vesselId}/main-engine/fuel-vs-rpm/${engineId}`;
  const params = {};

  if (!voyageId) {
    params.start = startDate;
    params.end = endDate;
  } else {
    params.voyageId = voyageId;
  }

  const res = await axios.get(url, { params });
  return res.data.data;
};

// Main Engine APIs Start
export const getVesselSpeedFuelConsumption = async (
  vesselId,
  engineId,
  startDate,
  endDate,
  voyageId = null
) => {
  const url = `/vessels/${vesselId}/main-engine/speed-consumption/${engineId}`;
  const params = {};

  if (!voyageId) {
    params.start = startDate;
    params.end = endDate;
  } else {
    params.voyageId = voyageId;
  }

  console.log("Params:", params.start, params.end);

  const res = await axios.get(url, { params });
  return res.data.data;
};

// SOG & Draft
export const getVesselSOGDraftData = async (
  vesselId,
  engineId,
  startDate,
  endDate,
  voyageId = null
) => {
  const url = `/vessels/${vesselId}/main-engine/sog-draft/${engineId}`;
  const params = {};

  if (!voyageId) {
    params.start = startDate;
    params.end = endDate;
  } else {
    params.voyageId = voyageId;
  }

  const res = await axios.get(url, { params });
  return res.data.data;
};

// Fuel Over Time
export const getVesselFuelOverTime = async (
  vesselId,
  engineId,
  startDate,
  endDate,
  voyageId = null
) => {
  const url = `/vessels/${vesselId}/main-engine/fuel-over-time/${engineId}`;
  const params = {};

  if (!voyageId) {
    params.start = startDate;
    params.end = endDate;
  } else {
    params.voyageId = voyageId;
  }

  const res = await axios.get(url, { params });
  return res.data.data;
};

// SOG vs Load
export const getVesselSOGOverLoad = async (
  vesselId,
  engineId,
  startDate,
  endDate,
  voyageId = null
) => {
  const url = `/vessels/${vesselId}/main-engine/sog-vs-load/${engineId}`;
  const params = {};

  if (!voyageId) {
    params.start = startDate;
    params.end = endDate;
  } else {
    params.voyageId = voyageId;
  }

  const res = await axios.get(url, { params });
  return res.data.data;
};
// Main Engine APIs End

// Auxiliary Engine APIs

// AE Load and Power Data
export const getVesselAuxEngineLoadAndPowerData = async (
  vesselId,
  engineId,
  startDate,
  endDate,
  voyageId = null
) => {
  const url = `/vessels/${vesselId}/aux-engine/load-data/${engineId}`;
  const params = {};

  if (!voyageId) {
    params.startDate = startDate;
    params.endDate = endDate;
  } else {
    params.voyageId = voyageId;
  }

  const res = await axios.get(url, { params });
  return res.data;
};

// AE Power Data
export const getVesselAuxEnginePowerData = async (
  vesselId,
  engineId,
  startDate,
  endDate,
  voyageId = null
) => {
  const url = `/vessels/${vesselId}/aux-engine/power-data/${engineId}`;
  const params = {};

  if (!voyageId) {
    params.startDate = startDate;
    params.endDate = endDate;
  } else {
    params.voyageId = voyageId;
  }

  const res = await axios.get(url, { params });
  return res.data; // Return full response, not res.data.data
};

export const getVesselAuxEngineFuelConsData = async (
  vesselId,
  engineId,
  startDate,
  endDate,
  voyageId = null
) => {
  const url = `/vessels/${vesselId}/aux-engine/fuel-cons/${engineId}`;
  const params = {};

  if (!voyageId) {
    params.startDate = startDate;
    params.endDate = endDate;
  } else {
    params.voyageId = voyageId;
  }

  const res = await axios.get(url, { params });
  return res.data.data;
};

export const getVesselAuxEngineSfocVsRpmData = async (
  vesselId,
  engineId,
  startDate,
  endDate,
  voyageId = null
) => {
  const url = `/vessels/${vesselId}/aux-engine/sfoc-rpm-data/${engineId}`;
  const params = {};

  if (!voyageId) {
    params.startDate = startDate;
    params.endDate = endDate;
  } else {
    params.voyageId = voyageId;
  }

  const res = await axios.get(url, { params });
  return res.data.data;
};

// Boiler Data
export const getVesselBoilerOverview = async (
  vesselId, 
  startDate, 
  endDate, 
  voyageId = null  // Add voyageId parameter
) => {
  const url = `/vessels/${vesselId}/boiler-engine/overview`;
  const params = {};

  // VOYAGE FILTER PRIORITY: If voyage is selected, ignore date range
  if (!voyageId) {
    params.start = startDate;
    params.end = endDate;
  } else {
    params.voyageId = voyageId;
  }

  const res = await axios.get(url, { params });
  return res.data;
};

export const getVesselBoilerEmissionAnalysis = async (
  vesselId, 
  startDate, 
  endDate, 
  voyageId = null
) => {
  const url = `/vessels/${vesselId}/boiler-engine/emision-analysis`;
  const params = {};

  if (!voyageId) {
    params.start = startDate;
    params.end = endDate;
  } else {
    params.voyageId = voyageId;
  }

  const res = await axios.get(url, { params });
  return res.data;
};

export const getVesselBoilerFuelConsumption = async (
  vesselId, 
  startDate, 
  endDate, 
  voyageId = null
) => {
  const url = `/vessels/${vesselId}/boiler-engine/fuel-cons`;
  const params = {};

  if (!voyageId) {
    params.start = startDate;
    params.end = endDate;
  } else {
    params.voyageId = voyageId;
  }

  const res = await axios.get(url, { params });
  return res.data;
};

// Incinerator Data
export const getVesselIncineratorSummary = async (
  vesselId, 
  startDate, 
  endDate, 
  voyageId = null
) => {
  const url = `/vessels/${vesselId}/incinerator-engine/summary`;
  const params = {};

  if (!voyageId) {
    params.start = startDate;
    params.end = endDate;
  } else {
    params.voyageId = voyageId;
  }

  const res = await axios.get(url, { params });
  return res.data;
};

export const getVesselIncineratorEmissionAnalysis = async (
  vesselId, 
  startDate, 
  endDate, 
  voyageId = null
) => {
  const url = `/vessels/${vesselId}/incinerator-engine/emision-analysis`;
  const params = {};

  if (!voyageId) {
    params.start = startDate;
    params.end = endDate;
  } else {
    params.voyageId = voyageId;
  }

  const res = await axios.get(url, { params });
  return res.data;
};

export const getVesselIncineratorFuelConsumption = async (
  vesselId, 
  startDate, 
  endDate, 
  voyageId = null
) => {
  const url = `/vessels/${vesselId}/incinerator-engine/fuel-cons`;
  const params = {};

  if (!voyageId) {
    params.start = startDate;
    params.end = endDate;
  } else {
    params.voyageId = voyageId;
  }

  const res = await axios.get(url, { params });
  return res.data;
};

// IGG Data
export const getVesselIGGOverview = async (
  vesselId, 
  startDate, 
  endDate, 
  voyageId = null
) => {
  const url = `/vessels/${vesselId}/igg/overview`;
  const params = {};

  if (!voyageId) {
    params.start = startDate;
    params.end = endDate;
  } else {
    params.voyageId = voyageId;
  }

  const res = await axios.get(url, { params });
  return res.data;
};

export const getVesselIGGEmissionAnalysis = async (
  vesselId, 
  startDate, 
  endDate, 
  voyageId = null
) => {
  const url = `/vessels/${vesselId}/igg/emision-analysis`;
  const params = {};

  if (!voyageId) {
    params.start = startDate;
    params.end = endDate;
  } else {
    params.voyageId = voyageId;
  }

  const res = await axios.get(url, { params });
  return res.data;
};

export const getVesselIGGFuelConsumption = async (
  vesselId, 
  startDate, 
  endDate, 
  voyageId = null
) => {
  const url = `/vessels/${vesselId}/igg/fuel-cons`;
  const params = {};

  if (!voyageId) {
    params.start = startDate;
    params.end = endDate;
  } else {
    params.voyageId = voyageId;
  }

  const res = await axios.get(url, { params });
  return res.data;
};

export const getVesselMainEngines = async (
  vesselId
) => {
  const url = `/vessels/${vesselId}/main-engines`;

  const res = await axios.get(url);
  return res.data;
};

export const getVesselAuxEngines = async (
  vesselId
) => {
  const url = `/vessels/${vesselId}/aux-engines`;

  const res = await axios.get(url);
  return res.data;
};